import { string } from "@src/libs/yup";

export default string()
	.zipcode("Zipcode is invalid")
	.required("Please enter a zipcode");
